import { useEffect, useState } from "react";
import { useFormik } from "formik";
import {
  accesRoles,
  Dispatch,
  RootState,
  GET_DATA_USERS_TOKEN,
  apiInstance,
} from "shared";
import { useDispatch, useSelector } from "react-redux";
import { MenuActions } from "pages/autorization-payments/components/MenuActions";
import { ButtonAction, CustomFileUploader } from "shared/components";
import { columnsGridUsers } from "../helper/columnsGridUsers";
import { columnsUsersType } from "../types/columsUsers.types";
import { MenuItem } from "@mui/material";
import { fieldsFormUser } from "../helper/fieldsFormUsers";
import FormUpdateUsers from "../form-users/FormUpdateUsers";
import { FormUpdatePassword } from "../form-users/FormUpdatePassword";
import { FormAssociateDeduction } from "../form-users/FormAssociateDeduction";
import Swal from "sweetalert2";

export const useUserManagement = (user?: any) => {
  const dispatch = useDispatch<Dispatch>();
  const { content } = useSelector(
    (state: RootState) => state.electronicDocuments,
  );
  const { loading } = useSelector(
    (rootState: RootState) => rootState.loading.models.linkDocument,
  );
  const [dataFields, setDataFields] = useState<any[]>([]);
  const [columns, setColumns] = useState<any[]>([]);
  const [showForm, setShowForm] = useState(false);
  const [userToken, setUserToken] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const valuesResultsPages = [50, 100, 250, 500];

  const onCloseModal = () => {
    dispatch.messageModal.cleanStateMessage();
    dispatch.linkDocument.cleanState();
  };

  const createUser = (values?: any) => {
    dispatch.messageModal.setMessageModal({
      show: true,
      title: `${values ? "Editar" : "Crear nuevo"} usuario prestador`,
      onClose() {
        onCloseModal();
      },
      size: "large",
      description: <FormUpdateUsers user={values} userName={user} />,
    });
  };

  const updatePassword = (values: columnsUsersType) => {
    dispatch.messageModal.setMessageModal({
      show: true,
      title: `Editar contraseña a usuario prestador`,
      onClose() {
        onCloseModal();
      },
      size: "medium",
      description: <FormUpdatePassword user={values} />,
    });
  };

  const associateDeduction = (values: columnsUsersType) => {
    if (!values.employerIdNumber || values.employerIdNumber.trim() === "") {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "El número de identificación del empleador es requerido para asociar deducciones",
        confirmButtonText: "Aceptar",
      });
      return;
    }
    dispatch.messageModal.setMessageModal({
      show: true,
      title: `Asociar deducción`,
      onClose() {
        onCloseModal();
      },
      size: "large",
      description: <FormAssociateDeduction user={values} />,
    });
  };

  const toogleShowForm = () => setShowForm((prev) => !prev);

  const buildUrl = (valuesUrl: any) => {
    const url = `${process.env.REACT_APP_OAUTH}/users`;
    const params = {
      page: 1,
      size: 50,
      code: valuesUrl.code,
      employerIdNumber: valuesUrl.employerIdNumber,
      givenName: valuesUrl.name,
    };
    return { params, url };
  };

  const { handleChange, handleSubmit, values, resetForm } = useFormik({
    initialValues: {
      code: "",
      employerIdNumber: "",
      name: "",
    },
    onSubmit: (vls) => {
      const result = buildUrl(vls);
      dispatch.electronicDocuments.getAllUsersProviders(result.params, {
        url: `${process.env.REACT_APP_OAUTH}/users`,
        userToken,
      });
    },
    validateOnChange: false,
    enableReinitialize: true,
  });

  const getValue = (name: string) => {
    const valueField: any = Object.entries(values).find(
      ([key, value]) => key === name,
    );
    return valueField[1];
  };

  const getDataUsers = () => {
    userToken &&
      dispatch.electronicDocuments.getAllUsersProviders(
        { page: 1, size: 50 },
        { url: `${process.env.REACT_APP_OAUTH}/users`, userToken },
      );
    resetForm();
  };

  useEffect(() => {
    setDataFields(fieldsFormUser());
  }, []);

  useEffect(() => {
    dispatch.menuDrawer.changeSelectedIndex(5);
    getDataUsers();
  }, [userToken]);

  useEffect(() => {
    const columnsTransform: any[] = [
      ...columnsGridUsers(),
      {
        field: "actions",
        headerName: "",
        minWidth: 120,
        renderCell(params: columnsUsersType) {
          return (
            <MenuActions>
              <MenuItem>
                <ButtonAction
                  roles={accesRoles.adminUser}
                  disabled={false}
                  action={() => {
                    updatePassword(params);
                  }}
                >
                  <span>Cambiar contraseña</span>
                </ButtonAction>
              </MenuItem>
              <MenuItem>
                <ButtonAction
                  roles={accesRoles.adminUser}
                  disabled={false}
                  action={() => {
                    createUser(params);
                  }}
                >
                  <span>Editar información</span>
                </ButtonAction>
              </MenuItem>
              <MenuItem>
                <ButtonAction
                  roles={accesRoles.adminUser}
                  disabled={false}
                  action={() => {
                    associateDeduction(params);
                  }}
                >
                  <span>Asociar deducción</span>
                </ButtonAction>
              </MenuItem>
            </MenuActions>
          );
        },
      },
    ];
    setColumns(columnsTransform);
  }, [content, createUser, updatePassword, associateDeduction]);

  const getDataToken = async () => {
    setIsLoading(true);
    try {
      const response = await apiInstance.get(GET_DATA_USERS_TOKEN);
      setUserToken(response.data.access_token);
    } catch (error) {
      console.error("Error fetching token:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    dataFields,
    handleChange,
    handleSubmit,
    toogleShowForm,
    createUser,
    getValue,
    onCloseModal,
    getDataToken,
    getDataUsers,
    showForm,
    columns,
    valuesResultsPages,
    loading,
    isLoading,
  };
};
